import { req, useConfig } from './api';

export const useRenovacionesFijos = () => useConfig('renovaciones_fijos');

export const validateAccountNumber = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/validateAccountNumber`,
  data: query,
}, null);

export const renovationValidate = phone => req({
  method: 'GET',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/orders/renovation/validate/${phone}`,
}, null);

export const retrievePlan = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/retrievePlan`,
  data: query,
}, null);

export const retrieveAportado = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/retrieveAportadoNumber`,
  data: query,
}, null);

export const retrieveBillHistoryList = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/retrieveBillHistoryList`,
  data: query,
}, null);

export const retrieveStatusBalance = query => req({
  method: 'POST',
  // url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_bo_backend/residentService/retrieveStatusBalance`,
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/retrieveStatusBalance`,
  data: query,
}, null);

export const getRenewalIMSI = query => req({
  method: 'POST',
  // url: `http://10.218.41.90:4854/tienda_en_linea_RG1/resources/consultaBSCS`,
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/consultaBSCS`,
  data: query,
}, null);

export const renewalTracer = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/orders/tracerRenovation`,
  data: query,
}, null);

export const createRenocionService = query => req({
  method: 'POST',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_bo_backend/residentService/createLocalRenovation`,
  data: query,
}, null);

export const clientOffer = id => req({
  method: 'GET',
  url: `${process.env.NEXT_PUBLIC_MONGO_API}${process.env.NEXT_PUBLIC_MERCHANT}/clients/${id}/offer`,
}, null);

export const getRecurrence = orderId => req({
  method: 'GET',
  url: `${process.env.NEXT_PUBLIC_SERVICES}/payments/htech/recurrence/${process.env.NEXT_PUBLIC_MERCHANT}/renewal/${orderId}`,
}, null);

export const getRenovationKey = () => req({
  method: 'GET',
  url: `${process.env.NEXT_PUBLIC_AMXGW_HOST}/tl_backend/ManagementProperties/property/get?key=MICLARO_RENO_KEY`,
}, null);

export const putRecurrence = (orderId, query) => req({
  method: 'PUT',
  url: `${process.env.NEXT_PUBLIC_SERVICES}/payments/htech/recurrence/${process.env.NEXT_PUBLIC_MERCHANT}/renewal/${orderId}`,
  data: query,
}, null);
